import { authorCourse, terrainPreset, type HolePlan } from './courseAuthoring';
import { plans } from './coursePlans';

export const summitLakeMetadata = {
  id: 'summit-lake',
  name: 'Summit Lake',
  description:
    'An elevated alpine test routed through evergreens and along an exposed mountain lake.',
  environmentPreset: 'alpine-cool',
  metadata: {
    location: 'Summit County, Colorado',
    regionType: 'alpine lake',
    difficulty: 82,
    typicalWind: [5, 22] as const,
    greenSpeed: [10.5, 11.5] as const,
    firmness: 'medium-firm' as const,
    primaryChallenge: 'Elevation, uneven lies, lake-edge approaches and changing mountain wind',
    signatureHoles: [4, 8, 13, 18],
    tournamentEventId: 'event-7',
    previewTheme: 'cool-alpine-lake',
    environmentPalette: {
      fairway: '#507b61',
      rough: '#315847',
      bunker: '#c8c0a5',
      water: '#397c9b',
      haze: '#b9d4dc',
    },
    vegetationStyle: 'dense spruce and alpine fir',
    terrainStyle: terrainPreset('alpine-relief', 24, 145, 1.15).id,
  },
};
const pars = [4, 4, 5, 3, 4, 4, 4, 5, 3, 4, 5, 3, 4, 4, 3, 4, 5, 4];
const yards = [
  430, 405, 560, 185, 455, 515, 390, 210, 425, 440, 545, 170, 410, 465, 195, 420, 555, 470,
];
const names = [
  'Timberline',
  'Cold Stream',
  'Snowmelt',
  'Lake Below',
  'High Pass',
  'Long Ascent',
  'Pines',
  'Downhill Run',
  'Mirror Lake',
  'Switchback',
  'Evergreen Reach',
  'Boulder',
  'Hidden Shelf',
  'North Wind',
  'Blue Water',
  'Last Climb',
  'Summit Chance',
  'Lakefront',
];
const options: Partial<HolePlan>[] = [];
options[3] = { water: 'green', elevation: { tee: 18, landing: 5, green: 0 } };
options[7] = { water: 'right', elevation: { tee: 24, landing: 10, green: -5 } };
options[12] = { elevation: { tee: 0, landing: 10, green: 22 }, bunkerCount: 4 };
options[17] = {
  water: 'green',
  landingZones: [{ distance: 275, width: 34, preferredSide: 'left' }],
};
export const createSummitLakeDocument = () =>
  authorCourse({
    ...summitLakeMetadata,
    plans: plans(names, pars, yards, options).map((p) => ({ ...p, trees: p.trees ?? 7 })),
  });
